@if (issue.scanStatus === 'failed') {
  <div>
    GuardDuty scan failed for this EC2 instance. Look for scan ID
    <span class="strong-text">{{ issue.scanId }}</span> in the GuardDuty Malware scans on the AWS console for more
    details.
  </div>
} @else {
  <div>
    <div class="strong-text">
      {{ issue.description }}
    </div>
    <div>
      <ul id="threat-list">
        @for (infection of issue.infectedFiles; track infection) {
          <li>
            Malware Type: {{ infection.malwareType }}
            <ul id="file-list">
              @for (file of infection.files; track file) {
                <li>
                  {{ file }}
                </li>
              }
              @if (infection.files.length < infection.totalFileCount) {
                <li>... and {{ infection.totalFileCount - infection.files.length }} more files</li>
              }
            </ul>
          </li>
        }
      </ul>
    </div>
    <div class="padding-top">
      Visit <a [href]="issue.consoleLink" target="_blank">the GuardDuty console</a> for more scan details
    </div>
  </div>
}
